import AllServicesPage from "components/weddigservice/allservice";
import { useEffect } from "react";
import { DISPLAY_CATEGORY_TYPE } from "utils/constants";

const DeepLinkRedirect = () => {
  useEffect(() => {
    const packageName = "com.belivmart.app";
    const fallbackWebUrl = "https://belivmart.com";
    const fallbackPlayStoreUrl = `https://play.google.com/store/apps/details?id=${packageName}`;
    const path = window.location.pathname.replace("/go", ""); // keep the path segment after /go

    const ua = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(ua);

    if (isAndroid) {
      const intentUrl = `intent://${path}#Intent;scheme=https;package=${packageName};end`;

      // Try to open app via intent
      window.location.href = intentUrl;

      // If app not installed, fallback to Play Store after short delay
      setTimeout(() => {
        window.location.href = fallbackPlayStoreUrl;
      }, 1500);
    } else {
      // For iOS or desktop, fallback to your web app
      window.location.href = fallbackWebUrl;
    }
  }, []);

  return <AllServicesPage displayCategoryType={DISPLAY_CATEGORY_TYPE.Food} />;
};

export default DeepLinkRedirect;
